import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipperHQModalHeader: {
    description: 'Shipping Details From ShipperHQ Modal Header',
    defaultMessage: 'Shipping Details From ShipperHQ',
    id: 'D8ifTc',
  },
  overview: {
    description: 'ShipperHQ Overview',
    defaultMessage: 'Overview',
    id: 'z/18DH',
  },
  customerSelectedShipping: {
    description: 'Customer Selected Shipping label',
    defaultMessage: 'Customer Selected Shipping',
    id: 'ooxIdA',
  },
  orderNumberLabel: {
    description: 'Overview > Order Label',
    defaultMessage: 'Order',
    id: 'jWP6jp',
  },
  totalShippingPriceLabel: {
    description: 'Overview > Total Shipping Price Label',
    defaultMessage: 'Total Shipping Price',
    id: 'rLF4tj',
  },
  createdLabel: {
    description: 'Overview > Created Time Label',
    defaultMessage: 'Created',
    id: '2h+kmY',
  },
  carrierTitleLabel: {
    description: 'Overview > Carrier Label',
    defaultMessage: 'Carrier',
    id: '/IZFDJ',
  },
  methodLabel: {
    description: 'Overview > Method Label',
    defaultMessage: 'Method',
    id: 'yb85Of',
  },
  shippingFromHeaderLabel: {
    description: 'Shipment Details, Shipping From Header Label',
    defaultMessage: 'Shipping From: {shipmentDetailName}',
    id: 'geM7m2',
  },
  shipmentDetailsHeaderLabel: {
    description: 'Shipment Details, Header Label',
    defaultMessage: 'Shipment Details',
    id: '+hxFtp',
  },
  shipmentInfoHeaderLabel: {
    description: 'Shipment Details, Shipment Info Header Label',
    defaultMessage: 'Shipment Info',
    id: 'AygvA8',
  },
  dateAndTimeHeaderLabel: {
    description: 'Shipment Details, Date and Time Header Label',
    defaultMessage: 'Date & Time',
    id: '9ckznY',
  },
  shippingFeesHeaderLabel: {
    description: 'Shipment Details, Shipping Fees Header Label',
    defaultMessage: 'Shipping Fees',
    id: 'c/ZxKM',
  },
  dispatchDateHeaderLabel: {
    description: 'Shipment Details, Dispatch Date Header Label',
    defaultMessage: 'Dispatch Date',
    id: 'eRp+bQ',
  },
  shippingFeeHeaderLabel: {
    description: 'Shipment Details, Shipping Fee Header Label',
    defaultMessage: 'Shipping Fee',
    id: 'uuz1JK',
  },
  methodHeaderLabel: {
    description: 'Shipment Details, Method Header Label',
    defaultMessage: 'Method',
    id: '4dL3a/',
  },
  deliveryDateHeaderLabel: {
    description: 'Shipment Details, Delivery Date Header Label',
    defaultMessage: 'Delivery Date',
    id: 'eK57OY',
  },
  handlingFeeHeaderLabel: {
    description: 'Shipment Details, Handling Fee Header Label',
    defaultMessage: 'Handling Fee',
    id: 'uS4hu0',
  },
  pickupLocationHeaderLabel: {
    description: 'Shipment Details, Pickup Location Header Label',
    defaultMessage: 'Pickup Location',
    id: 'NeygJj',
  },
  pickupLocationIdHeaderLabel: {
    description: 'Shipment Details, Pickup Location Id Header Label',
    defaultMessage: 'Pickup Location ID',
    id: 'CKoVkK',
  },
  totalChargesHeaderLabel: {
    description: 'Shipment Details, Total Charges Header Label',
    defaultMessage: 'Total Charges',
    id: 'zAwYs8',
  },
  packageDetailsHeader: {
    description: 'Package Details, Header',
    defaultMessage: 'Package Details',
    id: 'hXofcy',
  },
  itemsHeader: {
    description: 'Package Details, Items Header',
    defaultMessage: 'Items',
    id: '2TeObg',
  },
  onErrorMessage: {
    description: 'Package Details, onError Message',
    defaultMessage: 'We cannot currently retrieve the requested details from ShipperHQ. Please try again later.',
    id: 'XF/BV+',
  },
});
